module.exports = __webpack_public_path__ + "static/media/shufersal.41d11c54.png";